export const PROPS_END_DATE = "endDate";
export const PROPS_FIELD_GUID_LIST = "fieldGuidList";
export const PROPS_REPORT_FILTER = "filter";
export const PROPS_REPORT_PAGE_OPTIONS = "pageOptions";
export const PROPS_REPORT_SORT_LIST = "sortOptions";
export const PROPS_START_DATE = "startDate";
